// Format number and remove .00
// Only booking detail is using this filter
export function NumberFormatPipe($filter) {
  return function (amount, decimals) {
    amount = amount ? (amount * 1).toFixed(2) : 0.0;

    let value = $filter('number')(amount);
    // split into parts
    let parts = value.split('.');
    let number = parts[0];
    let cents = parts[1] || '00';
    cents = cents.substring(0, 2) === '00' ? cents.substring(2) : '.' + cents; // remove "00" cent amount

    return number + cents;
  };
}

NumberFormatPipe.$inject = ['$filter'];
